import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AuthorizedRouteElement} from '../../components/AuthorizedRouteElement.tsx';

export const ApplicationProductsLayout = () => {

    return (
        <Routes>
            <Route
                path='/'
                element={
                    <AuthorizedRouteElement rbacAction='ListApplicationProducts' redirectTo='/'>
                        <IndexPage/>
                    </AuthorizedRouteElement>
                }
            />
        </Routes>
    );
};
